import { Card, Empty, Space, Table, Tag, Typography } from 'antd';
import moment from 'moment';
import { MdOutlineLocalOffer } from 'react-icons/md';

import { formatCurrency } from '../../utils/format';
import './Product.less';

const { Text } = Typography;

/** Хоосон утгыг "-" болгож харуулна */
const val = (value) => (value === null || value === undefined || value === '' ? '-' : value);

/**
 * Хямдралын төлөв. Backend нь уншилт бүр дээр isActive-ыг бодож өгдөг тул
 * түүнд тулгуурлана.
 *
 * Fallback дээр endAt-ыг ЯГ ТЭР МӨЧӨӨР харьцуулна. Өмнө нь endOf('day') нэмж
 * бодож байсан нь буруу: endAt аль хэдийн зөв мөчийг агуулдаг (ModalAddSale нь
 * үүсгэх үедээ endOf('day') хийчихсэн байдаг) тул дахин сунгавал өдрийн дундуур
 * дуусах хямдрал шөнө дунд хүртэл "Идэвхтэй" харагдана.
 */
const isSaleActive = (sale) => {
  if (typeof sale?.isActive === 'boolean') {
    return sale.isActive;
  }
  if (!sale?.endAt) {
    return true;
  }
  return moment(sale.endAt).isSameOrAfter(moment());
};

const saleColumns = [
  {
    title: '№',
    width: 20,
    align: 'center',
    render: (_, record, index) => <Text>{index + 1}</Text>,
  },
  {
    title: 'Барааны нэр',
    dataIndex: 'title',
    key: 'title',
    width: 200,
    render: (text) => val(text),
  },
  {
    title: 'Үнэ',
    dataIndex: 'priceBeforeSale',
    key: 'priceBeforeSale',
    width: 200,
    align: 'center',
    // Хямдрал дууссан бол үндсэн үнэ дахин хүчинтэй тул дарж зурахгүй
    render: (text, record) =>
      text ? <Text delete={isSaleActive(record)}>{formatCurrency(text)}</Text> : '-',
  },
  {
    title: 'Хямдарсан үнэ',
    dataIndex: 'saleValue',
    key: 'saleValue',
    width: 200,
    align: 'center',
    render: (text) => (text ? <Text strong>{formatCurrency(text)}</Text> : '-'),
  },
  {
    title: 'Хямдрал үргэлжлэх огноо',
    dataIndex: 'endAt',
    key: 'endAt',
    width: 200,
    // Цагийг ч харуулна — хямдрал өдрийн дундуур дуусаж болох тул зөвхөн
    // огноо харуулбал "яагаад дууссан" нь ойлгомжгүй болно.
    render: (_, record) => (record.endAt ? moment(record.endAt).format('YYYY-MM-DD HH:mm') : '-'),
  },
  {
    title: 'Төлөв',
    dataIndex: 'status',
    key: 'status',
    width: 120,
    align: 'center',
    render: (_, record) =>
      isSaleActive(record) ? (
        <Tag color="success">Идэвхтэй</Tag>
      ) : (
        <Tag color="default">Идэвхгүй</Tag>
      ),
  },
  {
    title: 'Тэмдэглэл',
    dataIndex: 'description',
    key: 'description',
    width: 200,
    render: (text) => val(text),
  },
];

const ProductSale = ({ detail = [] }) => {
  const sales = (detail ?? []).filter(Boolean);

  return (
    <Space direction="vertical" size={16} style={{ width: '100%', padding: 16 }}>
      <Card
        title={
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <MdOutlineLocalOffer style={{ display: 'block', fontSize: '1em' }} />
            Хямдрал
          </span>
        }
        size="middle"
        styles={{ body: { padding: sales.length ? 0 : undefined } }}
      >
        {sales.length > 0 ? (
          <Table
            size="large"
            columns={saleColumns}
            dataSource={sales}
            rowKey={(record, index) => record?._id ?? index}
            pagination={false}
            scroll={{ x: 'max-content' }}
          />
        ) : (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Хямдрал байхгүй байна."
            style={{ margin: 0 }}
          />
        )}
      </Card>
    </Space>
  );
};

export default ProductSale;
